import { render } from "./ContentPackagingComposer.vue?vue&type=template&id=1c8e6ae6&scoped=true"
import script from "./ContentPackagingComposer.vue?vue&type=script&lang=js"
export * from "./ContentPackagingComposer.vue?vue&type=script&lang=js"

import "./ContentPackagingComposer.vue?vue&type=style&index=0&id=1c8e6ae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8e6ae6"]])

export default __exports__